export class MancalaFailure {
    static MUST_DISTRIBUTE_YOUR_OWN_HOUSES = () => $localize `You must distribute one of your houses.`;
    static MUST_CHOOSE_NON_EMPTY_HOUSE = () => $localize `You should choose a non-empty house to distribute.`;
    static SHOULD_DISTRIBUTE = () => $localize `You should feed but you do not.`;
}
